import * as React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import { Authority, Permission } from '../account/Types';
import {
  PERMISSIONS,
  BUSINESS,
  NONE,
  FULL,
  MEMBER,
  PAYMENT,
  ACCOUNT,
  CREATE,
  UPDATE
} from '../account/Constants';
import  { StaffRequest, StaffRequestError, AccountModalMode } from './Types';
import { INITIAL_REQUEST, CREATE_MODE, EDIT_MODE } from './Constants';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Phone from 'react-phone-number-input';
import { isValidName, isValidEmail, isValidPhone, generateEnterValidErrorMessage } from '../util/Validation';
import { SignupState } from '../admin/signup.types';
import { BusinessResponse } from '../business/business.types';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { cannotDelete } from '../util/permission.util';
import { AuthState } from '../auth/auth.types';
import { AdminState } from '../admin/admin.types';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';

const PASSWORD_ERROR_MESSAGE = 'Confirm password has to match';

type Props = {
  readonly requestChangeHandler: (request: StaffRequest, mode: AccountModalMode) => void
  readonly modalOpenChangeHandler: (open: boolean) => void
  readonly mode: AccountModalMode
  readonly modalOpen: boolean
  readonly staffRequest: StaffRequest
  readonly checkEmailAvailability: (email: string) => Promise<Response>
  readonly signupState: SignupState
  readonly registerStaffAccount: (request: StaffRequest) => Promise<Response>
  readonly getBusiness: () => Promise<BusinessResponse>
  readonly edited: StaffRequest
  readonly updateStaffAccount: (request: StaffRequest) => Promise<Response>
  readonly deleteStaffAccount: (request: StaffRequest) => Promise<Response>
  readonly authState: AuthState
  readonly adminState: AdminState
};

type States = {
  readonly displayOnly: StaffRequest
  readonly loading: boolean
  readonly staffRequestError: StaffRequestError
  readonly openDeleteConfirmationModal: boolean
};

class CreateEditModalComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      displayOnly: props.mode === CREATE_MODE ? props.staffRequest : props.edited,
      loading: false,
      staffRequestError: {
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        passwordError: '',
        phoneError: '',
        authoritiesError: ''
      },
      openDeleteConfirmationModal: false
    };
  }

  componentWillUnmount() {
    this.setState({
      loading: false,
      openDeleteConfirmationModal: false
    });
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {
      this.setState({
        displayOnly: nextProps.mode === CREATE_MODE ? nextProps.staffRequest : nextProps.edited
      });
    }
  }

  render() {
    const { mode, modalOpen, checkEmailAvailability } = this.props;
    const { displayOnly, staffRequestError } = this.state;

    return (
      <div>
        <Dialog
          title={this.getTitle()}
          actions={[
            this.renderDeleteButton(),
            this.renderCancelButton(),
            this.renderCreateOrEditButton()
          ]}
          modal={true}
          open={modalOpen}
          contentStyle={{width: '85%', maxWidth: 'none'}}
          autoScrollBodyContent={true}
        >
          <div className="row mt-2 mb-2">
            <div className="col-4 text-center">
              <TextField
                className="material-input-required-red"
                hintText="Email"
                floatingLabelText="Email"
                value={displayOnly.email}
                fullWidth={true}
                onChange={this.handleEmailChange}
                errorText={staffRequestError.emailError}
                onBlur={() => {
                  checkEmailAvailability(displayOnly.email)
                  .then(res => {
                    switch (this.props.signupState.statusCode) {
                      case 200:
                        this.setState((prevState: States) => (
                          {staffRequestError: {...prevState.staffRequestError, emailError: ''}}
                        ));
                        break;
                      case 409:
                        this.setState((prevState: States) => (
                          {staffRequestError: {...prevState.staffRequestError, emailError: 'Email is taken'}}
                        ));
                        break;
                      default:
                        break;
                    }
                  });
                }}
                disabled={mode === EDIT_MODE}
              />
            </div>
            <div className="col-4 text-center">
              <TextField
                className="material-input-required-red"
                hintText="Password"
                floatingLabelText="Password"
                type="password"
                fullWidth={true}
                value={displayOnly.password}
                onChange={this.handlePasswordChange}
                errorText={staffRequestError.passwordError}
              />
            </div>
            <div className="col-4 text-center">
              <TextField
                className="material-input-required-red"
                hintText="Confirm Password"
                floatingLabelText="Confirm Password"
                type="password"
                fullWidth={true}
                value={displayOnly.confirmPassword}
                onChange={this.handleConfirmPasswordChange}
              />
            </div>
          </div>
          <div className="row mt-2 mb-5">
            <div className="col-4 text-center">
              <TextField
                className="material-input-required-red"
                hintText="First Name"
                floatingLabelText="First Name"
                fullWidth={true}
                value={displayOnly.firstName}
                onChange={this.handleFirstNameChange}
                errorText={staffRequestError.firstNameError}
              />
            </div>
            <div className="col-4 text-center">
              <TextField
                className="material-input-required-red"
                hintText="Last Name"
                floatingLabelText="Last Name"
                fullWidth={true}
                value={displayOnly.lastName}
                onChange={this.handleLastNameChange}
                errorText={staffRequestError.lastNameError}
              />
            </div>
            <div className="col-4">
              <TextField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText="Phone"
                errorText={staffRequestError.phoneError}
              >
                <Phone
                  countries={['CA']}
                  value={displayOnly.phone}
                  onChange={this.onPhoneChange}
                  convertToNational={true}
                />
              </TextField>
            </div>
          </div>
          <hr/>
          <div className="row mt-2 mb-2 justify-content-center">
            <div className="col-4 text-center">
              <h2>AUTHORITIES</h2>
            </div>
          </div>
          <div className="row mb-2 justify-content-center">
            <div className="col-12 text-center red animated fadeIn">
              {staffRequestError.authoritiesError}
            </div>
          </div>
          <div className="row mt-2 mb-2">
            {this.pickReq(this.props).authorities
              .map((a: Authority, i: number) => this.renderFeaturePermissionRow(a, i))}
          </div>
        </Dialog>
        {this.renderDeleteConfirmationModal()}
      </div>
    );
  }

  private renderDeleteConfirmationModal = (): JSX.Element => {
    if (this.state.openDeleteConfirmationModal) {
      return(
        <Dialog
          title={'Staff Delete Confirmation'}
          actions={[
            this.renderNoButton(),
            this.renderYesButton()
          ]}
          modal={true}
          open={this.state.openDeleteConfirmationModal}
        >
          Do you really want to delete the staff? This operation cannot be undone.
        </Dialog>
      );
    } else {
      return null;
    }
  }

  private renderNoButton = (): JSX.Element => {   
    return(
      <RaisedButton
        label="No"
        secondary={true}
        onClick={() => this.setState({ openDeleteConfirmationModal: false })}
        className="mr-3"
        disabled={this.state.loading}
      />
    );
  }

  private renderYesButton = (): JSX.Element => {
    if (this.state.loading) {
      return(
        <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            float: 'right',
            marginRight: '3rem'
          }}
        />
      );
    } else {
      return(
        <RaisedButton
          label="Yes"
          primary={true}
          onClick={() => this.callGivenApiMethod(this.props.deleteStaffAccount)}
        />
      );
    }
  }

  private pickReq = (props: Props): StaffRequest => props.mode === CREATE_MODE ? props.staffRequest : props.edited;

  private onPhoneChange = (newValue: string): void => {
    const { requestChangeHandler, mode } = this.props;

    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          phone: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          phoneError: isValidPhone(newValue, generateEnterValidErrorMessage('phone'))
        }
      },
      () => {
        requestChangeHandler(
          {
            ...this.pickReq(this.props),
            phone: newValue
          },
          mode
        ); 
      }
    );
  }

  private handleFirstNameChange = (e: React.FormEvent<{}>, newValue: string): void => {
    const { requestChangeHandler, mode } = this.props;

    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          firstName: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          firstNameError: isValidName(newValue) ? '' : generateEnterValidErrorMessage('first name')
        }
      },
      () => {
        requestChangeHandler(
          {
            ...this.pickReq(this.props),
            firstName: newValue
          },
          mode
        );
      }
    );
  }

  private handleLastNameChange = (e: React.FormEvent<{}>, newValue: string): void => {
    const { requestChangeHandler, mode } = this.props;
    
    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          lastName: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          lastNameError: isValidName(newValue) ? '' : generateEnterValidErrorMessage('last name')
        }
      },
      () => {
        requestChangeHandler(
          {
            ...this.pickReq(this.props),
            lastName: newValue
          },
          mode
        );
      }
    );
  }

  private handlePasswordChange = (e: React.FormEvent<{}>, newValue: string): void => {
    const { requestChangeHandler, mode } = this.props;

    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          password: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          passwordError: newValue === this.state.displayOnly.confirmPassword ? '' : PASSWORD_ERROR_MESSAGE
        }
      },
      () => {
        requestChangeHandler(
          {
            ...this.pickReq(this.props),
            password: newValue
          },
          mode
        );
      }
    );
  }

  private handleConfirmPasswordChange = (e: React.FormEvent<{}>, newValue: string): void => {
    const { requestChangeHandler, mode } = this.props;

    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          confirmPassword: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          passwordError: newValue === this.state.displayOnly.password ? '' : PASSWORD_ERROR_MESSAGE
        }
      },
      () => {
        requestChangeHandler(
          {
            ...this.pickReq(this.props),
            confirmPassword: newValue
          },
          mode
        );
      }
    );
  }

  private handleEmailChange = (e: React.FormEvent<{}>, newValue: string): void =>
    this.setState(
      {
        displayOnly: {
          ...this.state.displayOnly, 
          email: newValue
        },
        staffRequestError: {
          ...this.state.staffRequestError,
          emailError: isValidEmail(newValue, generateEnterValidErrorMessage('email'))
        }
      },
      () => {
        this.props.requestChangeHandler(
          {
            ...this.pickReq(this.props),
            email: newValue
          },
          this.props.mode
        );
      }
    )

  private renderFeaturePermissionRow = (a: Authority, i: number): JSX.Element => {
    return(
      <div className="col-4">
        <div className="row no-gutters">
          <div className="col-6">
            <TextField
              floatingLabelText="Feature"
              fullWidth={true}
              value={a.feature}
              disabled={true}
              style={{fontSize: 12}}
            />
          </div>
          <div className="col-6">
            <SelectField
              value={a.permission}
              floatingLabelText="Permission"
              fullWidth={true}
              style={{fontSize: 12}}
              onChange={(e: React.SyntheticEvent<{}>, index: number, p: Permission) => this.onPermissionChange(a, i, p)}
            >
              {this.renderPermissionOptions(a)}
            </SelectField>
          </div>
        </div>
      </div>
    );
  }

  private renderPermissionOptions = (a: Authority): Array<JSX.Element> => {
    if (a.feature === BUSINESS) {
      return(
        PERMISSIONS
        .filter((permission: Permission) => permission !== NONE && permission !== FULL)
        .map((p: Permission, index: number) => {
          return <MenuItem key={index} value={p} primaryText={p} />;
        })
      );
    } else {
      return(
        PERMISSIONS.map((p: Permission, index: number) => {
          return <MenuItem key={index} value={p} primaryText={p} />;
        })
      );
    }
  }

  private onPermissionChange = (a: Authority, i: number, p: Permission): void => {
    const { requestChangeHandler, mode } = this.props;

    requestChangeHandler(
      {
        ...this.pickReq(this.props),
        authorities: [
          ...this.pickReq(this.props).authorities.slice(0, i),
          {feature: a.feature, permission: p},
          ...this.pickReq(this.props).authorities.slice(i + 1, this.pickReq(this.props).authorities.length)
        ]
      },
      mode
    );
  }

  private getTitle = (): string => `${this.props.mode} Staff Account`;

  private renderDeleteButton = (): JSX.Element => {
    if (this.state.loading) {
      return(
        this.renderLoading()
      );
    } else {
      return(
        <RaisedButton
          label="DELETE"
          secondary={true}
          onClick={() => this.setState({ openDeleteConfirmationModal: true })}
          disabled={
            this.props.mode === CREATE_MODE ||
            cannotDelete(ACCOUNT, this.props.authState, this.props.adminState)
          }
        />
      );
    }
  }

  private renderLoading = (): JSX.Element => {
    return(
      <RefreshIndicator
        size={40}
        left={10}
        top={0}
        status="loading"
        style={{
          display: 'inline-block',
          position: 'relative',
          float: 'right',
          marginRight: '3rem'
        }}
      />
    );
  }

  private renderCreateOrEditButton = (): JSX.Element => {
    const { mode, registerStaffAccount, updateStaffAccount } = this.props;

    if (this.state.loading) {
      return(
        this.renderLoading()
      );
    } else {
      return(
        <RaisedButton
          label={mode}
          primary={true}
          onClick={() =>
            mode === CREATE_MODE ?
              this.callGivenApiMethod(registerStaffAccount) :
              this.callGivenApiMethod(updateStaffAccount)
          }
          disabled={this.errorExists() || this.inputIncomplete() || !this.isChanged()}
        />
      );
    }
  }

  private isChanged = (): boolean => {
    const { mode, edited, staffRequest } = this.props;
    return mode === CREATE_MODE ?
      true :
      edited.firstName !== staffRequest.firstName || edited.lastName !== staffRequest.lastName ||
      edited.password !== staffRequest.password || edited.confirmPassword !== staffRequest.confirmPassword ||
      edited.phone !== staffRequest.phone || this.areAuthoritiesChanged();
  }

  private areAuthoritiesChanged = (): boolean => {
    const { staffRequest, edited } = this.props;
    return !edited.authorities.every((value: Authority) =>
      staffRequest.authorities.filter((a: Authority) =>
        a.feature === value.feature && a.permission === value.permission
      ).length === 1
    );
  }

  private errorExists = (): boolean => {
    const { staffRequestError } = this.state;
    return staffRequestError.emailError !== '' ||
      staffRequestError.firstNameError !== '' ||
      staffRequestError.lastNameError !== '' ||
      staffRequestError.passwordError !== '' ||
      staffRequestError.phoneError !== '' ||
      staffRequestError.authoritiesError !== '';
  }

  private inputIncomplete = (): boolean => {
    if (this.props.mode === CREATE_MODE) {
      const { staffRequest } = this.props;
      return staffRequest.email === '' || staffRequest.firstName === '' || staffRequest.lastName === '' ||
        staffRequest.password === '' || staffRequest.confirmPassword === '' || staffRequest.phone === '';
    } else {
      const { edited } = this.props;
      return edited.email === '' || edited.firstName === '' || edited.lastName === '' || edited.phone === '';
    }
  }

  private renderCancelButton = (): JSX.Element => {
    return(
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose}/>
    );
  }

  private handleClose = (): void =>
    this.setState(
      {displayOnly: INITIAL_REQUEST},
      () => {
        this.props.requestChangeHandler(INITIAL_REQUEST, this.props.mode);
        this.props.modalOpenChangeHandler(false);
      }
    )

  private callGivenApiMethod = (f: (staffRequest: StaffRequest) => Promise<Response>): void => {
    const { getBusiness, modalOpenChangeHandler } = this.props;

    this.setState(
      {loading: !isAuthTokenExpired()},
      () => {
        f(this.pickReq(this.props))
        .then(response => {
          getBusiness()
          .then(res => {
            this.setState((prevState) =>
              ({
                loading: false,
                openDeleteConfirmationModal: false
              }),
              () => modalOpenChangeHandler(false)
            );
          });
        });
      }
    );
  }

}

export default CreateEditModalComponent;



// WEBPACK FOOTER //
// ./src/staff/CreateEditModalComponent.tsx